import { createRouter, createWebHashHistory } from 'vue-router'
import { logout, tenantInfo, uc } from '@/api/login'
import { getAuthRoute, isAuthRouter } from '@/service/auth'
import { UPDATE_ROUTE } from '@/store/types'

const homeGroups = [
  {
    icon: 'people',
    name: 'roompush',
    title: '微信群发',
    path: '/',
  },
  {
    icon: 'control',
    name: 'roomcontrol',
    title: '安卓群控',
    path: '/',
  },
  {
    icon: 'control',
    name: 'admin',
    title: '管理员',
    path: '/',
  },
]

const routes = [
  {
    path: '/',
    component: () => import('src/views/layout/Index.vue'),
    meta: {
      menu: true,
      groups: homeGroups,
    },
    children: [
      // {
      //   path: '/',
      //   name: 'Home',
      //   component: () => import('src/views/home/Index'),
      //   meta: {
      //     title: '概览',
      //     showInSide: true,
      //   },
      // },
      {
        path: 'trust',
        name: 'GroupTrust',
        component: () => import('src/views/trust/Index.vue'),
        meta: {
          group: 'roompush',
          tp: 'roompush',
          title: '群托管',
          showInSide: true,
        },
      },
      {
        path: '/trust/create',
        name: 'CreateGroupTrust',
        component: () => import('src/views/trust/CreateTrust.vue'),
        meta: {
          title: '新建',
          group: 'roompush',
          tp: 'roompush',
          showInSide: false,
          breadcrumbItems: [
            {
              text: '群托管',
              to: { name: 'GroupTrust' },
            },
            {
              text: '新建',
            },
          ],
        },
      },
      {
        path: '/trust/group/:id',
        name: 'GroupList',
        group: 'roompush',
        tp: 'roompush',
        component: () => import('src/views/trust/GroupList.vue'),
        meta: {
          tp: 'roompush',
          group: 'roompush',
          customBreadcrumb: true,
          title: '群列表',
          showInSide: false,
        },
      },
      {
        path: 'roomPushList',
        name: 'RoomPushList',
        component: () => import('src/views/operating/Index.vue'),
        meta: {
          tp: 'roompush',
          group: 'roompush',
          title: '群发消息',
          showInSide: true,
        },
      },
      {
        path: '/roomPushList/send',
        name: 'SendPush',
        component: () => import('src/views/operating/SendPush.vue'),
        meta: {
          tp: 'roompush',
          group: 'roompush',
          title: '创建',
          showInSide: false,
          breadcrumbItems: [
            {
              text: '群发消息',
              to: { name: 'RoomPushList' },
            },
            {
              text: '创建',
            },
          ],
        },
      },
      {
        path: 'welcome',
        name: 'WelcomeList',
        component: () => import('src/views/operating/Welcome.vue'),
        meta: {
          tp: 'roompush',
          group: 'roompush',
          title: '群欢迎语',
          showInSide: true,
        },
      },
      {
        path: '/welcome/send',
        name: 'SendWelcome',
        component: () => import('src/views/operating/SendWelcome.vue'),
        meta: {
          tp: 'roompush',
          group: 'roompush',
          title: '创建',
          showInSide: false,
        },
      },
      {
        path: 'material',
        name: 'Material',
        component: () => import('src/views/operating/Material.vue'),
        meta: {
          tp: 'roompush',
          group: 'roompush',
          title: '群发素材',
          showInSide: true,
        },
      },
      // {
      //   path: '/trade',
      //   name: 'Trade',
      //   component: () => import('src/views/trade/Index'),
      //   meta: {
      //     title: '交易中心',
      //     showInSide: true,
      //   },
      // },
      // {
      //   path: '/trade/record',
      //   name: 'Record',
      //   component: () => import('src/views/trade/Record'),
      //   meta: {
      //     title: '充值记录',
      //     showInSide: false,
      //     breadcrumbItems: [
      //       {
      //         text: '充值中心',
      //         to: { name: 'Trade' },
      //       },
      //       {
      //         text: '充值记录',
      //       },
      //     ],
      //   },
      // },
      {
        path: 'control',
        name: 'Control',
        redirect: { name: 'ControlTask' },
      },
      {
        path: 'control/task',
        name: 'ControlTask',
        component: () => import('src/views/task/Index.vue'),
        meta: {
          tp: 'roomcontrol',
          group: 'roomcontrol',
          title: '朋友圈',
          showInSide: true,
        },
      },
      {
        path: 'control/task/create',
        name: 'CreateControlTask',
        component: () => import('src/views/task/Create.vue'),
        meta: {
          tp: 'roomcontrol',
          group: 'roomcontrol',
          title: '新建',
          showInSide: false,
          breadcrumbItems: [
            {
              text: '朋友圈',
              to: { name: 'ControlTask' },
            },
            {
              text: '新建',
            },
          ],
        },
      },
      {
        path: 'control/console',
        name: 'ControlConsole',
        component: () => import('src/views/console/Index.vue'),
        meta: {
          tp: 'roomcontrol',
          group: 'roomcontrol',
          title: '群控',
          showInSide: true,
        },
      },
      {
        path: 'ai/reply',
        name: 'ControlAI',
        component: () => import('@/views/ai/reply/Index.vue'),
        meta: {
          tp: 'airole',
          group: 'roomcontrol',
          title: 'AI参考回复提示词',
          showInSide: true,
        },
      },
      {
        path: 'ai/reply/create',
        name: 'CreateControlAI',
        component: () => import('@/views/ai/reply/edit.vue'),
        meta: {
          tp: 'airole',
          group: 'roomcontrol',
          title: '新建',
          showInSide: false,
          breadcrumbItems: [
            {
              text: 'AI参考回复提示词',
              to: { name: 'ControlAI' },
            },
            {
              text: '新建',
            },
          ],
        },
      },
      {
        path: 'ai/reply/edit',
        name: 'EditControlAI',
        component: () => import('@/views/ai/reply/edit.vue'),
        meta: {
          tp: 'airole',
          group: 'roomcontrol',
          title: '编辑',
          showInSide: false,
          breadcrumbItems: [
            {
              text: 'AI参考回复提示词',
              to: { name: 'ControlAI' },
            },
            {
              text: '编辑',
            },
          ],
        },
      },
      {
        path: 'ai/analyze',
        name: 'UserAnalyze',
        component: () => import('@/views/ai/user_analyze/Index.vue'),
        meta: {
          tp: 'airole',
          group: 'roomcontrol',
          title: 'AI用户分析提示词',
          showInSide: true,
        },
      },
      {
        path: 'ai/evaluate',
        name: 'Evaluate',
        component: () => import('@/views/ai/eval/Index.vue'),
        meta: {
          tp: 'airole',
          group: 'roomcontrol',
          title: 'AI对话分析提示词',
          showInSide: true,
        },
      },
      {
        path: 'ai/evaluate/create',
        name: 'CreateEvaluateAI',
        component: () => import('@/views/ai/eval/edit.vue'),
        meta: {
          tp: 'airole',
          group: 'roomcontrol',
          title: '新建',
          showInSide: false,
          breadcrumbItems: [
            {
              text: 'AI对话分析提示词',
              to: { name: 'Evaluate' },
            },
            {
              text: '新建',
            },
          ],
        },
      },
      {
        path: 'ai/evaluate/edit',
        name: 'EditEvaluateAI',
        component: () => import('@/views/ai/eval/edit.vue'),
        meta: {
          tp: 'airole',
          group: 'roomcontrol',
          title: '编辑',
          showInSide: false,
          breadcrumbItems: [
            {
              text: 'AI对话分析提示词',
              to: { name: 'Evaluate' },
            },
            {
              text: '编辑',
            },
          ],
        },
      },
      {
        path: 'evaluate',
        name: 'ServiceEvaluate',
        component: () => import('@/views/service_evaluate/Index.vue'),
        meta: {
          tp: 'airole',
          group: 'roomcontrol',
          title: '对话分析',
          showInSide: true,
        },
      },
      {
        path: 'device',
        name: 'ControlDevice',
        component: () => import('src/views/wechat_control/device/Index.vue'),
        meta: {
          tp: 'roomcontrol',
          group: 'roomcontrol',
          title: '设备管理',
          showInSide: true,
        },
      },
      {
        path: '/admin',
        name: 'Admin',
        component: () => import('src/views/admin/Index.vue'),
        meta: {
          icon: 'admin',
          title: '管理员',
          showInSide: true,
        },
      },
    ],
  },
  {
    path: '/control/console/m',
    name: 'ControlConsoleM',
    component: () => import('src/views/console/IndexForH5.vue'),
    meta: {
      tp: 'roomcontrol',
      group: 'roomcontrol',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('src/views/login/Index.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (!$store.getters.isLogin) {
    try {
      await uc()
      await tenantInfo()
    } catch (err) {
      if (!err.response || err.response.status !== 401) {
        await logout()
      }
      if (to.name !== 'Login') {
        next({
          name: 'Login',
          replace: true,
        })
      } else {
        next()
      }
      return
    }
  }
  if (to.name === 'Login' || to.name === '/' || to.name === undefined) {
    if (window.screen.width < 500) {
      // 先跳转，如没有权限会再次跳转到有权限的页面
      next({
        name: 'ControlConsoleM',
        replace: true,
      })
      return
    }
    const authRoute = getAuthRoute(router.options.routes[0].children)
    if (to.name !== authRoute) {
      next({
        name: authRoute,
        replace: true,
      })
      return
    }
  }
  if (!isAuthRouter(to)) {
    const authRoute = getAuthRoute(router.options.routes[0].children)
    if (to.name !== authRoute) {
      next({
        name: authRoute,
        replace: true,
      })
      return
    }
  }
  next()
})

router.afterEach((to) => {
  $store.commit(UPDATE_ROUTE, to.name)
})

export default router
